const moduleDetails = [
  {
    heading: "Introduction to Stock Markets",
    content: [
      {
        heading: "The Need to Invest",
        content:
          "Learn about the importance of savings. Identify avenues to invest the savings in suitable investment vehicle. Compare historical returns generated by different assets, and know what to expect from you ",
      },
      {
        heading: "Regulators",
        content:
          "Find out who and how the regulators govern the financial markets and also understand different types of financial market participants. Understand the need to regulate the markets.",
      },
      {
        heading: "Financial Intermediaries",
        content:
          "An overview of the financial intermediaries in the Indian stock market and the services they offer. ..",
      },
      {
        heading: "The IPO Markets – Part 1",
        content:
          "Understand the origins of business and the funding environment of business. Learn about the different funding stages and also learn how funding works. ..",
      },
      {
        heading: "The IPO Markets – Part 2",
        content:
          "Learn the basics of the IPO market and the process of how to go about investing in IPO’s. This chapter also helps us understand the different IPO Jargons that are commonly used. ..",
      },
      {
        heading: "The Stock Markets",
        content:
          "We explore the basics of stock trading and understand what makes the stock move on a minute by minute basis. We also explore concept of return calculation. ..",
      },
      {
        heading: "The Stock Markets Index",
        content:
          "An overview of the Indian Stock Market Indices, their construction, and practical uses in trading ..",
      },
      {
        heading: "Commonly Used Jargons",
        content:
          "Glossary of common stock market terms & associated concepts used in trading. We also explain in detail on how to short a stock. ..",
      },
      {
        heading: "The Trading Terminal",
        content:
          "An introduction to The Trading Terminal, its interface, various functionalities and relevant concepts .. ",
      },
      {
        heading: "Clearing and Settlement Process",
        content:
          "The behind the scene operations involved in share buying & selling ..",
      },
      {
        heading: "Five Corporate Actions and Its Impact on Stock Prices",
        content:
          "Various corporate actions and the effect they have on the share prices and trading activity. Keys things you need to know before subscribing for a corporate action ..",
      },
      {
        heading: "Getting started!",
        content:
          "Learn about the importance of developing a Point of View on stock markets, its impact, and its relevance to developing a strategy while trading stocks. ..",
      },
      {
        heading: "Supplementary note – Rights, OFS, FPO",
        content:
          "The note discovers the various options available to companies to raise funds before and after getting listed in the secondary markets ..",
      },
      {
        heading: "Supplementary note – The 20 market depth or level 3 data",
        content:
          "The 20 Market Depth (level 3 data) Window I’ve driven a car for many years and I’ve even changed my car a few times now. Each time I changed my car, the engine remained more or less the same, but ..",
      },
    ],
  },
  {
    heading: "Technical Analysis",
    content:
      "Technical Analysis (TA) plays an important role in developing a point of view. Like every other research, TA also has its own attributes. In this module, we will discover all those complex attributes of TA, study various patterns, indicators and theories that will help you as a trader to find upright trading opportunities in the market.",
    color: " #B5B2EA",
  },
  {
    heading: "Fundamental Analysis",
    content:
      "Fundamental Analysis (FA) is a holistic approach to study a business. If you are an investor that is looking for long term investments this module will help you understand Equity research, help you in reading the financial statements, annual reports, calculation of Financial Ratio, Analysis and most importantly  ",
    color: " #48CBFF",
  },
  {
    heading: "Futures Trading",
    content:
      "Futures Trading involves trading in contracts in the derivatives markets. This module covers the various intricacies involved in undergoing a futures trade including margins, leverages,  ",
    color: "#64B2FF",
  },
  {
    heading: "Options Theory for Professional Trading",
    content:
      "An option is a contract where the price of the options is based on an underlying. Options contracts grant the buyer the right to buy the underlying without a compulsory obligation.",
    color: " #78DDB9",
  },
  {
    heading: "Option Strategies",
    content:
      "The module covers various options strategies that can be built with a multi-dimensional approach based on Market trend involving Option Greeks, Risk-Return, etc.",
    color: "#ECC3A7",
  },
  {
    heading: "Markets and Taxation",
    content:
      "As a trader in India, you should be informed of all the taxes that are levied on your investments and account. This module overlays the taxation countenance of Investing/Trading in the Markets. It also outlines the various essential topics like calculation of your turnover, how to prepare a balance sheet and the P&L statement, and further about how you can file  ",
    color: " #EACF32",
  },
  {
    heading: "Currency, Commodity, and Government",
    content:
      "This module covers the Currency,  MCX Commodity contract, and the Government Securities (GSec) traded in the Indian Markets.",
    color: "#D1C36F",
  },
  {
    heading: "Risk Management & Trading Psychology",
    content:
      "The module covers the risk management aspect along with the psychology required for being consistent and profitable while trading.",
    color: "#99B4FF",
  },
  {
    heading: "Trading Systems",
    content:
      "Have you considered building your own Trading System? Well, then this module is for you. The major components of building a good trading system are input parameters and interpreting output alongside decision-making. In this module, we will learn about all the components and much more including the techniques and different types of Trading Systems.",
    color: " #FFA9BA",
  },
  {
    heading: "Personal Finance (Part 1)",
    content:
      "Personal finance is an essential aspect of your financial life as it helps you achieve your short term and long term financial goals. This module encompasses the various aspects of personal finance such as retirement planning, Mutual funds, ETFs, Bonds, and goal-oriented investments",
    color: " #4EDFEA",
  },
  {
    heading: "Innerworth — Mind over markets",
    content:
      "A series of articles on the psychology of trading, that will guide you mend your thought and prepare you psychologically to become a novice trader.",
    color: " #4EDFEA",
  },
];

export default moduleDetails;
